const ACTIVE_KEY = 'tenantSlug';
const HISTORY_KEY = 'tenantSlugHistory';
const HISTORY_LIMIT = 5;

export const TENANT_HISTORY_EVENT = 'tenantHistoryUpdated';

const hasWindow = () => typeof window !== 'undefined';

const normalizeSlug = (slug: string) => slug.trim().toLowerCase();

const readHistory = (): string[] => {
    if (!hasWindow()) return [];
    try {
        const raw = window.localStorage.getItem(HISTORY_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : [];
    } catch {
        return [];
    }
};

const writeHistory = (history: string[]) => {
    if (!hasWindow()) return;
    window.localStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(0, HISTORY_LIMIT)));
};

export const getActiveTenantSlug = (): string | null => {
    if (!hasWindow()) return null;
    return window.localStorage.getItem(ACTIVE_KEY);
};

export const getTenantHistory = (): string[] => readHistory();

export const saveTenantSlug = (slug: string) => {
    if (!hasWindow()) return;
    const normalized = normalizeSlug(slug);
    if (!normalized) return;
    window.localStorage.setItem(ACTIVE_KEY, normalized);

    const history = readHistory();
    const nextHistory = [normalized, ...history.filter((item) => item !== normalized)].slice(0, HISTORY_LIMIT);
    writeHistory(nextHistory);
    window.dispatchEvent(new Event(TENANT_HISTORY_EVENT));
};

export const removeTenantFromHistory = (slug: string) => {
    if (!hasWindow()) return;
    const normalized = normalizeSlug(slug);
    const history = readHistory();
    const nextHistory = history.filter((item) => item !== normalized);
    writeHistory(nextHistory);
    window.dispatchEvent(new Event(TENANT_HISTORY_EVENT));
};

export const clearTenantStorage = () => {
    if (!hasWindow()) return;
    window.localStorage.removeItem(ACTIVE_KEY);
    window.localStorage.removeItem(HISTORY_KEY);
    window.dispatchEvent(new Event(TENANT_HISTORY_EVENT));
};
